import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import GlobalAlertDialog from "@/components/reusables/GlobalAlert";
import MobileSidebar from "@/components/siderbar/MobileSidebar";
import Sidebar from "@/components/siderbar/Sidebar";
import UnderConstruction from "@/components/state-pages/UnderConstructing";
import { formatToCapitalizedWords } from "@/lib/utils";
import { PermissionsManager } from "@/redux/manager/permissions-manager";
import { RootState } from "@/redux/store";
import { isRouteEnabled } from "@/utils/feature-flag/featureFlag.utils";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const expanded = useSelector((state: RootState) => state.config.expanded);

  const location = useLocation();

  const featureConfig = useSelector((state: RootState) => state.feature.config);
  const enabled = isRouteEnabled(location.pathname, featureConfig);

  const underConstructionPageTitle = location.pathname.split("/").pop();

  return (
    <>
      <PermissionsManager />
      <section className='relative flex gap-2 '>
        <Sidebar />

        <div
          className={`w-full h-screen overflow-y-scroll scrollbar-thin ${expanded ? "lg:ml-[250px]" : "ml-20"}`}
        >
          {/* <Navbar /> */}
          <main className='flex-1 flex-col max-w-screen w-full  px-4 gap-y-4 mx-auto mt-[1rem]'>
            <MobileSidebar />
            {enabled ? (
              children
            ) : (
              <UnderConstruction
                title={formatToCapitalizedWords(
                  underConstructionPageTitle?.replace("-", " ") ?? "",
                )}
              />
            )}
          </main>
        </div>
      </section>
      <GlobalAlertDialog />
    </>
  );
};

export default MainLayout;
